var _path, _path2, _circle, _circle2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgScissorOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8405 17.2768L6.38031 2.94418",
    stroke: "#161616",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45894 17.3315L18.762 1.88952",
    stroke: "#161616",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1105,
    cy: 18.1105,
    r: 3.25,
    transform: "rotate(90 18.1105 18.1105)",
    stroke: "#161616",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.11047,
    cy: 18.1105,
    r: 3.25,
    transform: "rotate(90 6.11047 18.1105)",
    stroke: "#161616",
    strokeWidth: 1.5
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgScissorOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scissor_open.4efc0b7fe9684872757ad798c427557a.svg";